const LINKS = [
  { label: "About", id: "#about-section" },
  { label: "Services", id: "#services-work" },
  { label: "Products", id: "#ebook-section" },
  { label: "FAQ", id: "#faq-section" },
  { label: "Articles", id: "#blog-section" },
];

export default function Footer({ onNav, onBook }) {
  return (
    <footer data-testid="site-footer" className="bg-[#232B22] text-white/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 lg:py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img src="/logo.jpeg" alt="Mended Alchemy" className="h-20 w-20 rounded-full object-cover" />
              <div>
                <p className="font-serif-display text-2xl text-white leading-none">Mended Alchemy</p>
                <p className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#C9B48A] mt-1.5">
                  Life &amp; Parenting Coaching
                </p>
              </div>
            </div>
            <p className="mt-6 max-w-sm font-serif-display text-lg italic text-[#C9B48A]">
              Grow Within. Parent Consciously. Thrive Together.
            </p>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-white/60">
              A purpose-led personal transformation and parenting venture founded by Priya Rawal.
            </p>
            <button
              onClick={onBook}
              data-testid="footer-book-button"
              className="mt-7 inline-flex items-center rounded-full bg-[#A8916B] px-6 py-3 text-sm font-medium text-white hover:bg-[#8A7656] transition-colors duration-200"
            >
              Book a Consultation
            </button>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono-accent text-[11px] uppercase tracking-[0.2em] text-white/40 mb-5">
              Explore
            </p>
            <div className="grid grid-cols-2 gap-3">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  onClick={() => onNav(l.id)}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-left text-sm text-white/70 hover:text-white transition-colors duration-200"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono-accent text-[11px] uppercase tracking-[0.2em] text-white/40 mb-5">
              Contact
            </p>
            <button
              onClick={() => onNav("#contact-section")}
              className="text-sm text-white/70 hover:text-white transition-colors duration-200"
            >
              Send us a message
            </button>
            <p className="mt-3 text-sm text-white/60">Virtual consultations worldwide</p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} Mended Alchemy — Life &amp; Parenting Coaching. All rights reserved.
          </p>
          <p className="text-xs text-white/40">Mothers first. Awareness before action.</p>
        </div>
      </div>
    </footer>
  );
}
